import { render } from "./cage-order-confirm.vue?vue&type=template&id=3b248aec"
import script from "./cage-order-confirm.vue?vue&type=script&lang=js"
export * from "./cage-order-confirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__